import { Component, Inject, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { GeolocationService } from 'src/app/services/geolocation.service';
import { AgmInfoWindow } from '@agm/core';

@Component({
  selector: 'app-bar-view-branch',
  templateUrl: './bar-view-branch.component.html',
  styleUrls: ['./bar-view-branch.component.scss']
})
export class BarViewBranchComponent implements OnInit {
  @Input() viewText:string = ""
  branchText:string = "Selecciona la sucursal deseada";
  cookieBranch: any = {};

  constructor(private coreService:CoreService, public cookies: CookieService, public dialog: MatDialog){
    if(this.cookies.get("Branch")){
      this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
      this.branchText = "Sucursal " + this.cookieBranch.nombre
    }
  }

  ngOnInit():void {
    this.coreService.emitSubjet.subscribe(response => {
      if (response.type === 'RefreshDetail') {
        if(this.cookies.get("Branch")){
          this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
          this.branchText = "Sucursal " + this.cookieBranch.nombre
        }
      }
    })
  }

  selectBranch(){
    const dialogRef = this.dialog.open(DialogBranch, {
      height: '80vh',
      width: '80vw',
      backdropClass: 'nina-dialog-backdrop',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      // if(this.cookies.get("Branch")){
      //   this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
        // this.branchText = "Sucursal " + this.cookieBranch.nombre
      // }
      location.reload();
    });
  }

}

@Component({
  selector: 'dialog-branch',
  templateUrl: 'dialog-branch.html',
  styleUrls: ['dialog-branch.scss']
})

export class DialogBranch {
  lat = 25.556428231042272;
  lng = -103.42911673490906;
  zoom = 13
  sucursal:any = {urlFoto:"../../../assets/img/JU.jpg", nombre: "JUAREZ", telefono:"732 86 31", celularSucursal:"732 86 31", direccion:"Av Juarez 3090 Ote, Col Centro, Torreon Coahuila", latitud:"", longitud:"", horario:"Lunes a Sábado de 8:00am a 9:00pm | Domingos de 10:00am a 9:00pm"}
  sucursalSelected:any = {}
  sucursales:any = []
  myLatitude: number = 0;
  myLongitude: number = 0;
  @ViewChildren('infoWindow') infoWindows!: QueryList<AgmInfoWindow>;
  previousInfoWindow: AgmInfoWindow | null = null;

  constructor(private coreService:CoreService, public dialogRef: MatDialogRef<DialogBranch>, @Inject(MAT_DIALOG_DATA) public data: any, public router:Router, public cookies: CookieService, public apiServices: ApiService, private geolocationService: GeolocationService) {
    if(this.cookies.get("Branch")){
      this.sucursalSelected = JSON.parse(this.cookies.get("Branch"))
    }
  }
  
  ngOnInit(): void {
    this.getUbication()
    
  }

  getUbication(){
    this.geolocationService.getLocation()
      .then(position => {
        this.myLatitude = position.coords.latitude;
        this.myLongitude = position.coords.longitude;
        // this.lat = position.coords.latitude;
        // this.lng = position.coords.longitude;
        this.getBranches()
      })
      .catch(error => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se ha permitido acceder a tu ubicación, esto nos ayudaria a brindarte un mejor servicio"} });
        // console.error('Error al obtener la ubicación:', error);
        this.getBranches()
      });
  }

  getBranches(){
    let data = {token: this.cookies.get('Token')}
    this.apiServices.getSucursales(data).subscribe({
      next: (value) => {
        if(this.myLatitude === 0){
          this.sucursales = value
        }
        else{
          let sucursalesFiltrar:any = []
          for (let index = 0; index < value.length; index++) {
            value[index].distancia ??= +this.calcularDistancia(this.myLatitude, this.myLongitude, +value[index].latitud, +value[index].longitud);
            if(value[index].distancia <= value[index].distanciaMaximaKms){
              sucursalesFiltrar.push(value[index])
            }
          }
          this.sucursales = [...sucursalesFiltrar]
        }
      },
      error: (err) => {
        // console.log(err)
      }
    })
  }

  selectedBranch(branch:any, infoWindow:AgmInfoWindow){
    this.sucursal = branch
    this.openInfoWindow(infoWindow)
  }

  calcularDistancia(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const radioTierra = 6371; // Radio de la Tierra en kilómetros
    const dLat = this.gradoARadianes(lat2 - lat1);
    const dLon = this.gradoARadianes(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.gradoARadianes(lat1)) * Math.cos(this.gradoARadianes(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distancia = radioTierra * c;

    return +distancia.toFixed(2);
  }
  
  gradoARadianes(grados: number): number {
    return grados * (Math.PI / 180);
  }

  selectBranch(){
    this.sucursalSelected = this.sucursal
    if(this.cookies.get("Branch")){
      this.cookies.delete("Branch");
    }
    this.cookies.set("Branch", JSON.stringify(this.sucursalSelected), {expires: 4, sameSite: 'Strict'});
    this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: 'Sucursal seleccionada "' + this.sucursalSelected.nombre + '"'}});
    this.dialogRef.close();
  }

  onMapClickEvent(event: any) {
    // this.latitude = event.coords.lat;
    // this.longitude = event.coords.lng;
  }

  markerDragEnd(event: any) {
    // this.latitude = event.coords.lat;
    // this.longitude = event.coords.lng;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openInfoWindow(infoWindow: AgmInfoWindow) {
    if (this.previousInfoWindow) {
      this.previousInfoWindow.close();
    }
    this.previousInfoWindow = infoWindow;
    infoWindow.open();
  }
}

